import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Menu } from "@mui/icons-material";
import { IconButton, Drawer } from "@mui/material";
import { useState } from "react";
import { HeaderWrapper, Logo, NavLinks } from "../common/__style";
import DrawerListManageTrips from "./DrawerListManageTrips";
var ManageTripsHeader = function (_a) {
    var layoutType = _a.layoutType;
    var _b = useState(false), drawerOpen = _b[0], setDrawerOpen = _b[1];
    var toggleDrawer = function (open) { return function () {
        setDrawerOpen(open);
    }; };
    return (_jsxs(HeaderWrapper, { children: [_jsx(Logo, { children: _jsx(IconButton, { color: "inherit", onClick: toggleDrawer(true), children: _jsx(Menu, {}) }) }), _jsx(Logo, { children: "CorpTrip" }), _jsx(NavLinks, {}), _jsx(Drawer, { anchor: "left", open: drawerOpen, onClose: toggleDrawer(false), children: _jsx(DrawerListManageTrips, {}) })] }));
};
export default ManageTripsHeader;
